// extracted by mini-css-extract-plugin
export default {"TestPackageCard":"TestSchedule_TestPackageCard__C0DD4","Icon":"TestSchedule_Icon__goy9b","Edit":"TestSchedule_Edit__RsTg+","Delete":"TestSchedule_Delete__by4JZ"};